export default {
  data () {
    return {
      software: []
    }
  },
  computed: {
    flattenedSoftware () {
      const ret = []

      // Sort software based on year, month, day, then alphabetical
      this.software.sort((a, b) => {
        const aDate = new Date(a.VersionedResources[0] ? a.VersionedResources[0].CreationDate : 0)
        const bDate = new Date(b.VersionedResources[0] ? b.VersionedResources[0].CreationDate : 0)

        if (aDate.getFullYear() !== bDate.getFullYear()) {
          return bDate.getFullYear() - aDate.getFullYear()
        } else if (aDate.getMonth() !== bDate.getMonth()) {
          return bDate.getMonth() - aDate.getMonth()
        } else if (aDate.getDay() !== bDate.getDay()) {
          return bDate.getDay() - aDate.getDay()
        } else {
          if (a.ResourceDescription < b.ResourceDescription) {
            return -1
          }
          if (a.ResourceDescription > b.ResourceDescription) {
            return 1
          }
          return 0
        }
      })

      this.software.forEach((item) => {
        if (item.IsPublic) {
          if (item.VersionedResources.length) {
            const versionedResources = []
            item.VersionedResources.forEach((res) => {
              const versionPart = res.MajorVersion + '.' + res.MinorVersion + '.' + res.ReleaseVersion + '.' + res.BuildVersion
              versionedResources.push({
                name: item.ResourceDescription,
                versionPart,
                file: { url: res.DownloadURL },
                externalIconUrl: item.ImageURL ? item.ImageURL : '?',
                publishDate: res.CreationDate,
                releaseNotesUrl: res.ReleaseNotesURL,
                isRelease: item.Level === 'Release',
                isLatest: false,
                isLegacy: item.IsLegacy
              })
            })
            /* sorting now happening on the server (Simon)
            versionedResources.sort((a, b) => {
              return new Date(b.publishDate) - new Date(a.publishDate)
            })
            */
            versionedResources[0].isLatest = true
            ret.push(...versionedResources)
          }
          item.UnversionedResources.forEach((res) => {
            ret.push({
              name: item.ResourceDescription,
              file: { url: res.DownloadURL },
              externalIconUrl: item.ImageURL ? item.ImageURL : '?',
              releaseNotesUrl: res.ReleaseNotesURL,
              isRelease: item.Level === 'Release',
              isLatest: true,
              isLegacy: item.IsLegacy
            })
          })
        }
      })
      return ret
    }
  }
}
